<template>
  <div>
    <div
      class="notification-card-section h-auto rounded-5 d-flex justify-content-between align-items-center nowrap pointer"
    >
      <!-- LEFT -->
      <div class="left-notify d-flex justify-content-start align-items-center nowrap">
        <div class="avatar" :class="icon_color_bg">
          <img v-lazy="dynamicImg('GirlOne.png')" alt class="avatar-img">
          <!-- <div class="avatar-text white-text font-weight-500" :class="setAvatarBg">AJ</div> -->
          <!-- <span class="icon-library font-19 brand_navy flex-center"></span> -->
          <!-- <span class="icon-video-card font-19 brand_tonic flex-center"></span> -->
        </div>

        <!-- NOTIFICATION INFO -->
        <div class="notification-info color_ash">
          <div class="notify-title">
            <span class="font-weight-bold">Andrew Jackson</span>
            &nbsp;
            <span>created an</span>&nbsp;
            <span class="notify-type font-weight-bold">homework</span>
          </div>
          <div class="notify-desc link-underline">Week 3 - Introduction to Mathematical Equations</div>
        </div>
      </div>

      <!-- RIGHT -->
      <div class="right-notify">
        <div class="view brand_accent_bg brand_navy rounded-40 pointer" ref="viewNode">View</div>
        <div class="date color_ash font-12" ref="dateNode">2d</div>
      </div>
    </div>
  </div>
</template>

<script>
import { colors, random, shuffle, setInitial } from "@/scripts/utilities";

export default {
  name: "NorificationCard",

  props: {
    type: String, //homework, live class, post, announcement
    description: String,
    date: String,
    sender_name: String,
    sender_image: String
  },

  data() {
    return {
      notification_title: null,
      notification_meta: null,
      icon_color_bg: "brand_red_light_bg"
    };
  },

  computed: {
    setAvatarBg() {
      let shuffled = shuffle(colors);
      return shuffled[random(15, 0)];
    },

    getInitial() {
      return setInitial(this.teacher_name);
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.notification-card-section {
  width: 100%;
  padding: 8px;
  margin-bottom: 4px;
  transition: all 0.3s ease-in-out;

  .left-notify {
    margin-right: 20px;

    .avatar {
      @include equal_min_edge(35);
      margin-right: 15px;
    }

    .notification-info {
      font-size: 13.5px;

      @include breakpoint_max(xl) {
        font-size: 13px;
      }

      @include breakpoint_max(md) {
        font-size: 12px;
      }

      .notify-title {
        margin-bottom: 3px;
      }
      .notify-desc {
        transition: all 0.3s ease-in-out;
        &:hover {
          color: $brand_tonic !important;
        }
      }
    }
  }

  .right-notify {
    .view {
      font-size: 11px;
      line-height: 14px;
      padding: 6px 10px;
      font-weight: 500;
      transition: all 0.4s ease-in-out;
      display: none;

      &:hover {
        background: $brand_inverse !important;
        color: $color_white !important;
      }
    }

    .date {
      transition: all 0.3s ease-in-out;
    }
  }

  &:hover {
    background: $color_white;

    .right-notify {
      .view {
        transition: all 0.5s ease-in-out;
        display: unset;
      }

      .date {
        transition: all 0.5s ease-in-out;
        display: none;
      }
    }
  }
}
</style>
